import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import { LogService } from "../../services/LogService";
import TextField from "../../components/fields/textField/TextField.vue";
import AutocompleteField from "../../components/fields/autocompleteField/AutocompleteField.vue";
import PeriodoField from "../../components/fields/periodoField/PeriodoField.vue";
import moment from "moment";
export default {
    name: "GerenciarLogs",
    components: {
        Breadcrumb,
        TextField,
        AutocompleteField,
        PeriodoField
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Logs',
                disabled: true
            }
        ],
        headers: [
            { text: 'Núm Func.', align: 'start', value: 'usuario.username' },
            { text: 'Nome Usuário', align: 'start', value: 'usuario.nome' },
            { text: 'Tabela', align: 'start', value: 'entidade.entidade' },
            { text: 'Evento', align: 'start', value: 'entidade.evento' },
            { text: 'Data Log', align: 'start', value: 'data' },
            { text: 'Id Registro', align: 'start', value: 'id' },
            { text: 'Identificador', align: 'start', value: 'identificador' },
        ],
        filters: {
            usernameLogFilter: null,
            nomeLogFilter: null,
            tabelaLogFilter: null,
            eventoLogFilter: null,
            idLogFilter: null,
            identificadorLogFilter: null,
            dadoLogFilter: null,
            dataInicio: null,
            dataFim: null,
        },
        items: [],
        itemSelected: [],
        tabelasOptions: [
            {
                text: 'Selecione',
                value: null,
            },
            {
                text: 'Ação',
                value: 'acao',
            },
            {
                text: 'Exercício',
                value: 'exercicio',
            }
        ],
        eventosOptions: [
            {
                text: 'Selecione',
                value: null,
            },
            {
                text: 'Inclusão',
                value: 'CRIAR',
            },
            {
                text: 'Alteração',
                value: 'EDITAR',
            },
            {
                text: 'Exclusão',
                value: 'EXCLUIR',
            }
        ],
        page: 1,
        totalItems: 0
    }),
    created() {
        this.listarLogsPaginado();
    },
    watch: {
        page: async function(newValue) {
            this.page = newValue;
            await this.listarLogsPaginado();
        }
    },
    methods: {
        async listarLogsPaginado() {
            try {
                const filter = this.prepareFormFilter();

                const response = await LogService.index(filter);

                if (typeof response !== 'string') {
                    this.items = response.data.data;
                    this.totalItems = response.data.total;
                    this.itemSelected = [];
                    this.$forceUpdate();
                } else {
                    console.error('Não foi possível obter os logs.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os logs:', error);
            }
        },

        clearFilters() {
            Object.keys(this.filters).forEach(key => {
                this.filters[key] = null;
            });
        },

        prepareFormFilter() {
            const filter = new FormData();

            filter.append("page", this.page);

            this.filters.usernameLogFilter
            ? filter.append(
                "username",
                this.filters.usernameLogFilter
            )
            : null;

            this.filters.nomeLogFilter
                ? filter.append(
                    "nome",
                    this.filters.nomeLogFilter
                )
                : null;

            this.filters.tabelaLogFilter
                ? filter.append(
                    "entidade",
                    this.filters.tabelaLogFilter
                )
                : null;

            this.filters.eventoLogFilter
                ? filter.append(
                    "evento",
                    this.filters.eventoLogFilter
                )
                : null;

            this.filters.idLogFilter
                ? filter.append(
                    "id",
                    this.filters.idLogFilter
                )
                : null;

            this.filters.identificadorLogFilter
                ? filter.append(
                    "identificador",
                    this.filters.identificadorLogFilter
                )
                : null;
            this.filters.dadoLogFilter
                ? filter.append(
                    "descricao",
                    this.filters.dadoLogFilter
                )
                : null;

            this.filters.dataInicio
                ? filter.append(
                    "data_ini",
                    moment(this.filters.dataInicio).format("YYYY-MM-DD")
                  )
                : null;
            this.filters.dataFim
                ? filter.append(
                    "data_fim",
                    moment(this.filters.dataFim).format("YYYY-MM-DD")
                  )
                : null;    
            return filter;
        },
    }
};
